/*
  TGC — dot pagination for the mobile product gallery.

  Dawn's <slider-component> ships prev/next arrows and an "n / total" counter, but
  no dots. The dot markup it does have lives in <slideshow-component>, which also
  brings autoplay and announcement-bar behaviour we don't want on a PDP — and
  swapping the element would sit underneath media-gallery.js's variant handling.

  So we render the dots ourselves and drive them off the `slideChanged` event that
  SliderComponent already dispatches on scroll. Nothing in Dawn is modified.
*/
(function () {
  'use strict';

  function slidesIn(viewer) {
    return Array.prototype.slice
      .call(viewer.querySelectorAll('.product__media-item'))
      .filter(function (slide) {
        return slide.clientWidth > 0;
      });
  }

  function setActive(dots, index) {
    dots.forEach(function (dot, i) {
      if (i === index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function buildDots(gallery) {
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewer || !viewer.slider) return;

    var existing = gallery.querySelector('.tgc-gallery-dots');
    if (existing) existing.remove();

    var slides = slidesIn(viewer);
    if (slides.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'tgc-gallery-dots';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', 'Product image');

    var dots = slides.map(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tgc-gallery-dots__dot';
      dot.setAttribute('aria-label', 'Go to image ' + (index + 1) + ' of ' + slides.length);
      dot.addEventListener('click', function () {
        viewer.slider.scrollTo({
          left: slide.offsetLeft - slides[0].offsetLeft,
          behavior: 'smooth',
        });
      });
      nav.appendChild(dot);
      return dot;
    });

    // Mirror whichever slide is already active (a variant image may be selected).
    var initial = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    setActive(dots, initial < 0 ? 0 : initial);

    viewer.addEventListener('slideChanged', function (event) {
      setActive(dots, event.detail.currentPage - 1);
    });

    viewer.insertAdjacentElement('afterend', nav);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section on setting changes.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('media-gallery').forEach(buildDots);
  });
})();
